export default {
    game_id: "joker_81_dice",
    gameName : "Joker 81 Dice",

    stageWidth: 1280,
    stageHeight: 720,

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
        'framework/src/vendor/ph.js',
    ],

    ["wallet"]: {
        ["creditBets"]: {
            ["$default"]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        },

        ["defaultCreditBet"]: {
            ["$default"]: 1
        },

        ["denominations"]: {
            ["$default"]: [0.1, 0.25, 0.5, 1, 1.25, 2.5]
        }
    },

    game: {
        audio: {
            tracks: []
        },
        freespins: {
            autostart: true
        },
        webfonts: [
            //your other webfonts, if any
            "UbuntuMono-Regular",
            "Audiowide-Regular",
        ]
    },
    system: {
        audio: {
            tracks: [
                {
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},

            ]
        }
    }
}